import { combineReducers } from 'redux'
import * as redukers from 'reduker'
import * as actionTypes from './action-types'

export default combineReducers({
  request: redukers.request({
    start: actionTypes.FETCH_INVITATIONS,
    success: [actionTypes.SET_INVITATIONS, actionTypes.SET_PAGINATION],
    error: actionTypes.SET_FETCH_INVITATIONS_ERROR,
  }),
  list: redukers.entities({
    update: actionTypes.SET_INVITATIONS,
    mergeById: actionTypes.UPDATE_INVITATION,
  }),
  selectedIds: redukers.value(
    {
      set: actionTypes.SET_SELECTED,
      reset: actionTypes.RESET_SELECTED,
    },
    {},
  ),
  pagination: redukers.value(
    {
      set: actionTypes.SET_PAGINATION,
    },
    { page: 1, limit: 0, pages: 0, total: 0 },
  ),
  getSearchOptions: redukers.request({
    start: actionTypes.GET_SEARCH_OPTIONS,
    clear: actionTypes.CLEAR_SEARCH_OPTIONS,
  }),
  searchOptions: redukers.value(
    {
      set: actionTypes.SET_SEARCH_OPTIONS,
      reset: actionTypes.CLEAR_SEARCH_OPTIONS,
    },
    [],
  ),
  searchFilters: redukers.value(
    {
      set: actionTypes.SET_SEARCH_FILTERS,
      reset: actionTypes.RESET_SEARCH_FILTERS,
    },
    { keyword: '' },
  ),
  removeRequest: redukers.request({
    start: actionTypes.REMOVE,
    error: actionTypes.REMOVE_ERROR,
    success: actionTypes.REMOVE_SUCCESS,
  }),
})
